import React from 'react'
import {Box, Flex, Text} from '../../vanilla'
import {Address} from '../../types/loqate'
import {escapeStringForRegExp} from '../../utils/utils'
import {ChevronRightIcon} from '../icons'

interface AddressSearchItemProps {
  onSelectAddress: (address: Address) => void
  address: Address
}

export const AddressSearchItem = (props: AddressSearchItemProps) => {
  const {address, onSelectAddress} = props

  const onSelect = () => onSelectAddress(address)

  const getHighlightedSearchText = (address: Address) => {
    const [textHighlight, descHighlight] = address?.Highlight?.split(';') ?? []
    let text = address.Text
    let desc = address.Description

    const getTemplate = (part: string) => `<b>${part}</b>`

    if (address.Text && textHighlight) {
      const indexHighlightRanges = textHighlight.split(',')

      for (const range of indexHighlightRanges) {
        const [start, end] = range.split('-')
        const part = address.Text.substring(+start, +end)
        if (part) {
          const regex = new RegExp(escapeStringForRegExp(part), 'i')
          text = text.replace(regex, getTemplate(part))
        }
      }
    }

    if (address.Description && descHighlight) {
      const indexHighlightRanges = descHighlight.split(',')

      for (const range of indexHighlightRanges) {
        const [start, end] = range.split('-')
        const part = address.Description.substring(+start, +end)
        if (part) {
          const regex = new RegExp(escapeStringForRegExp(part), 'i')
          desc = desc.replace(regex, getTemplate(part))
        }
      }
    }

    return {
      text: text ?? address.Text,
      desc: desc ?? address.Description,
    }
  }

  const {text, desc} = getHighlightedSearchText(address)

  return (
    <Flex
      position="relative"
      width="full"
      paddingX="12px"
      paddingY="8px"
      alignItems="center"
      justifyContent="space-between"
      onClick={onSelect}
      overflow="visible"
      cursor="pointer"
      bg={{default: 'white', hover: 'gray25'}}
      paddingRight="32px"
    >
      <Box style={{whiteSpace: 'nowrap'}}>
        <Text
          as="span"
          variant="text1"
          letterSpacing="base"
          lineHeight="shorter"
          color="black"
          style={{whiteSpace: 'nowrap', fontFamily: 'arial'}}
          dangerouslySetInnerHTML={{__html: text}}
        />{' '}
        <Text
          variant="unstyled"
          as="em"
          fontSize="xs"
          lineHeight="shorter"
          letterSpacing="base"
          style={{color: '#6B6B6B', whiteSpace: 'nowrap', fontFamily: 'arial'}}
          dangerouslySetInnerHTML={{__html: desc}}
        />
      </Box>

      {address.Type !== 'Address' && (
        <ChevronRightIcon
          position="absolute"
          width="12px"
          style={{right: 8, top: 'calc(50% - 8.5px)', color: '#6B6B6B'}}
        />
      )}
    </Flex>
  )
}
